/**
 * Navigation-related constants for the ANYW3AR webapp
 */

/**
 * Delay (in milliseconds) before redirecting after successful auth operations.
 *
 * Used after:
 * - Email verification (signup flow)
 * - Password reset (forgot password flow)
 *
 * Duration: 3000ms (3 seconds)
 * Rationale: Provides enough time for users to read success toast messages
 */
export const SUCCESS_REDIRECT_DELAY_MS = 3000;
